/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.store', [
            'ui.router',
            'emarket.store.home',
            'emarket.store.post',
            'emarket.store.search',
            'emarket.store.static',
            'emarket.store.categories'
        ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('store', {
                url: '/tienda/:name',
                abstract: true,
                views: {
                    app: {
                        templateUrl: 'store/template.tpl.html',
                        controller: 'StoreController as model'
                    }
                },
                resolve: {
                    profile: ['$stateParams', '$state', 'Profile', function($stateParams, $state, Profile) {
                        return Profile.$search({
                            username: $stateParams.name
                        })
                            .$asPromise()
                            .then(function(stores) {
                                var store = stores[0];
                                if (store.plan.product.price > 0) {
                                    return store;
                                } else {
                                    $state.go('main.post.search', { usuario: store.username });
                                }
                            });
                    }],
                    categories: ['$stateParams', 'Profile', function($stateParams, Profile) {
                        return Profile.getCategories($stateParams.name);
                    }]
                }
            });
        }]);
}());

/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.store', [
            'ui.router',
            'emarket.store.home',
            'emarket.store.post',
            'emarket.store.search',
            'emarket.store.static',
            'emarket.store.categories'
        ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('store', {
                url: '/tienda/:name',
                abstract: true,
                views: {
                    app: {
                        templateUrl: 'store/template.tpl.html',
                        controller: 'StoreController as model'
                    }
                },
                resolve: {
                    profile: ['$stateParams', '$state', 'Profile', function($stateParams, $state, Profile) {
                        return Profile.$search({
                            username: $stateParams.name
                        })
                            .$asPromise()
                            .then(function(stores) {
                                var store = stores[0];
                                if (store.plan.product.price > 0) {
                                    return store;
                                } else {
                                    $state.go('main.post.search', { usuario: store.username });
                                }
                            });
                    }],
                    categories: ['$stateParams', 'Profile', function($stateParams, Profile) {
                        return Profile.getCategories($stateParams.name);
                    }]
                }
            });
        }]);
}());
